import React, { useState } from "react";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
import Anchor from "../elements/Anchor";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/autoplay";

import "../../styles/components/slices/faq.scss";

const Faq = ({ slice }) => {
  if (!slice) return null;
  const bgColor = slice.primary.background_color;

  const [swiper, setSwiper] = useState(null);
  const [isActive, setIsActive] = useState(0);

  const slideTo = (index) => {
    if (swiper) swiper.slideTo(index);
  };

  const handleActive = (index) => {
    setIsActive(index);
  };

  return (
    <Container
      fluid
      className="faq"
      style={
        bgColor
          ? {
              backgroundColor: bgColor,
            }
          : {
              backgroundColor: "#fff",
            }
      }
    >
      <Container className="text-image max-container">
        <Row>
          <Col md={9}>
            <h3 className="title-65">{slice.primary.title.text}</h3>
          </Col>
        </Row>
        {/* Desktop */}
        <Row className="mt-5 d-none d-md-block">
          <Col className="position-relative">
            <Swiper
              modules={[Autoplay, Pagination]}
              onSwiper={setSwiper}
              className="faq-slider"
            >
              {slice.items.map((slide) => (
                <SwiperSlide key={slide.title} className="d-flex faq-slider">
                  <div className="descr me-3">
                    <PrismicRichText field={slide.description.richText} />
                  </div>
                  <div className="col-3">
                    <GatsbyImage
                      image={slide.image.gatsbyImageData}
                      alt={slide.image.alt || "slider image"}
                      className="image"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            <Row>
              <Col md={9} className="faq-questions p-4">
                <Row>
                  {slice.items.map((item, index) => (
                    <Col
                      md={6}
                      key={item.title}
                      className={`${
                        isActive === index ? "active mb-3" : "mb-3"
                      }`}
                      onClick={() => {
                        slideTo(index);
                        handleActive(index);
                      }}
                    >
                      <div className="faq-title">
                        <p className="text-white">{item.title}</p>
                      </div>
                    </Col>
                  ))}
                  <div className="col">
                    <Anchor
                      href={slice.primary.button_link.url}
                      className="text-center d-block p-3 read-more-btn"
                      target={slice.primary.button_link.target}
                    >
                      {slice.primary.button_label}
                    </Anchor>
                  </div>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Mobile */}
        <Row className="d-flex d-md-none">
          <Swiper
            slidesPerView="auto"
            modules={[Navigation]}
            className="slider-mobile"
          >
            {slice.items?.map((box, index) => (
              <SwiperSlide key={index}>
                <Col
                  md={8}
                  key={box.title}
                  className={`${
                    isActive === index ? "active my-4 p-1" : "my-4 p-1"
                  }`}
                  onClick={() => {
                    slideTo(index);
                    handleActive(index);
                  }}
                >
                  <div className="faq-title">
                    <p>{box.title}</p>
                  </div>
                </Col>
              </SwiperSlide>
            ))}
            <Col>
              <div className="description mt-3">
                <PrismicRichText
                  field={slice.items[isActive].description.richText}
                />
              </div>
            </Col>
            <div className="col">
              <Anchor
                href={slice.primary.button_link.url}
                className="text-center d-block p-3 read-more-btn"
                target={slice.primary.button_link.target}
              >
                {slice.primary.button_label}
              </Anchor>
            </div>
          </Swiper>
        </Row>
      </Container>
    </Container>
  );
};

export default Faq;
